import React, { useEffect, useState } from 'react';
import { skeleTonJson } from '../common/jsonDumb';
import NftCard from '../Card/NftCard';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { collection, getDocs, query, where } from 'firebase/firestore/lite';

export default function OnSellsTab(props) {
  const [nftDataArr, setnftDataArr] = useState([]);
  const [loadingNfts, setloadingNfts] = useState(true);

  useEffect(() => {
    if (props.artistId) {
      getArtistNfts();
    }
  }, [props.artistId]);

  const getArtistNfts = async () => {
    setloadingNfts(true);

    let nftRef = query(
      collection(firebaseFireStore, 'musicartNfts'),
      where('adminState', '==', 'ACCEPT'),
      where('activeInMarketPlace', '==', true),
      where('artistId', '==', props.artistId),
    );

    let nftData = await getDocs(nftRef);
    let dataArr = [];

    nftData.forEach((doc) => {
      let cObj = doc.data();
      if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
        let startingPrice = 0;
        Object.values(cObj.multipleNftDetails)
          .filter((x) => x.activeInMarketPlace)
          .map((ele, index) => {
            if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
              if (
                ele.nftSaleType &&
                ele.nftSaleType !== 'Auctioning' &&
                ele.price &&
                (!startingPrice ||
                  (startingPrice && Number(ele.price) < startingPrice))
              ) {
                startingPrice = Number(ele.price);
              } else if (
                ele.nftSaleType &&
                ele.nftSaleType === 'Auctioning' &&
                ele.auctionEndTime &&
                ele.minBiddingPrice &&
                (!startingPrice ||
                  (startingPrice &&
                    Number(ele.minBiddingPrice) < startingPrice))
              ) {
                startingPrice = Number(ele.minBiddingPrice);
              }
            }
          });
        if (startingPrice || cObj.preview) {
          dataArr.push({ ...cObj, startingPrice: startingPrice });
        }
      } else {
        if (
          (cObj.nftSaleType &&
            cObj.nftSaleType === 'Auctioning' &&
            cObj.auctionEndTime &&
            cObj.minBiddingPrice) ||
          (cObj.nftSaleType !== 'Auctioning' && cObj.price) ||
          cObj.preview
        ) {
          dataArr.push(cObj);
        }
      }
    });

    dataArr.sort((a, b) => Number(b.likes) - Number(a.likes));

    setnftDataArr([...dataArr]);
    setloadingNfts(false);
  };

  return (
    <div className="seller__tab__pane" role="tabpanel">
      <div className="seller__tab__content">
        <div className="row row--grid">
          {loadingNfts
            ? skeleTonJson.map((ele, index) => (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens-artist"
                  key={'nft-' + index}
                >
                  <NftCard
                    // nftDataArr={nftDataArr}
                    ele={ele}
                    index={index}
                    // setNFTDataArr={setNFTDataArr}
                  />
                </div>
              ))
            : nftDataArr.map((ele, index) => {
                if (
                  (ele.nftSaleType &&
                    ele.nftSaleType === 'Auctioning' &&
                    ele.auctionEndTime) ||
                  ele.nftSaleType !== 'Auctioning'
                ) {
                  return (
                    <div
                      style={{ display: 'block' }}
                      className="turning-screens-artist"
                      key={'nft-' + index}
                    >
                      <NftCard
                        nftDataArr={nftDataArr}
                        ele={ele}
                        index={index}
                        nftDataArr={nftDataArr}
                        setnftDataArr={setnftDataArr}
                        category={'tab_on_sale'}
                      />
                    </div>
                  );
                }
              })}
          {!loadingNfts && nftDataArr.length === 0 && (
            <div className="text-center w-full text-blueGray-500">
              <p className="text-center mt-10">0 NFTs found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
